// extracted by mini-css-extract-plugin
module.exports = {"slider":"HomePage_slider__2OCO2","content":"HomePage_content__1Vt_c","images":"HomePage_images__2XaCc","container":"HomePage_container__3_Mii"};